import React from 'react';

export default function useBrowserEffect(callback: () => any) {
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      callback();
    }
  }, [typeof window]);
}
